import React from 'react';
import './WideCollegeCard.css';
import { IoLocationOutline, IoGlobeOutline } from 'react-icons/io5';
import { HiOutlineCurrencyRupee } from "react-icons/hi";
import { FaStar } from 'react-icons/fa';
import collegePlaceholder from '../../assets/images/ftrdClgImgPlaceholder.png';

const WideCollegeCard = ({ college }) => {
  const formatFees = (fee) => {
    if (!fee) return "N/A";
    if (fee >= 100000) {
      return `₹${(fee / 100000).toFixed(2)} Lakhs`;
    }
    return `₹${fee}`;
  };

  return (
    <div className="wide-college-card">
      <div className="wide-college-image-wrapper">
        <img src={collegePlaceholder} alt={college.name} className="wide-college-img" />
      </div>
      
      <div className="wide-college-info">
        <div>
            <div className="wide-college-header">
            <h3 className="wide-college-name">{college.name}</h3>
            <span className="wide-college-ranking">NIRF ranking {college.ranking || college.nirf_ranking || 'N/A'}</span>
            </div>
            
            <p className="wide-college-desc">
              {college.description || `${college.name} is a ${college.authority || 'premier'} ${college.cType?.name || 'educational'} institute in ${college.city || college.town || "City"}, ${college.state}.${college.examAccepted ? ` Accepts ${college.examAccepted}.` : ''}`}
            </p>

            <div className="wide-college-meta">
                <div className="wide-meta-item">
                    <IoLocationOutline />
                    <span>{college.town || college.city || college.district || "City"}, {college.state}</span>
                </div>
                
                {/* Fees in the middle */}
                <div className="wide-meta-item">
                    <HiOutlineCurrencyRupee />
                    <span>{college.totalFee || college.fees || college.totalFees || (college.lowFee ? `${formatFees(college.lowFee)} - ${formatFees(college.highFee)}` : 'Fees N/A')}</span>
                </div>
                
                <div className="wide-meta-item">
                    <span style={{ fontWeight: 'bold', marginRight: '4px' }}>{college.rating || 4.5}</span>
                    <div className="stars">
                        <FaStar /><FaStar /><FaStar /><FaStar /><FaStar />
                    </div>
                </div>
            </div>
        </div>

        <a 
          href={college.website || "#"} 
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => !college.website && e.preventDefault()}
          className="wide-official-link"
        >
          Open Official website <IoGlobeOutline />
        </a>
      </div>
    </div>
  );
};

export default WideCollegeCard;
